module.exports = __webpack_public_path__ + "static/media/40penedo.715d918a.mp3";